/**
 * RecoveryController
 *
 * This is a class as opposed to an object (RecoveryController = {};) because it's self contained
 *
 */
(function () {
  class RecoveryController {
    constructor() {
      this._task = undefined;
      this._commandsToSend = [];
    }

    initialise() {
      messageBus.subscribe(
        "common:RecoverGameListener",
        this.onRecoverGameListener.bind(this)
      );
      this._disclaimerFunc = this.onDisclaimerVisible.bind(this);
      this._introVisibleFunc = this.onIntroVisible.bind(this);
      this._waitForInputFunc = this.onWaitForInput.bind(this);
      this._handledCommand = this.onHandledCommand.bind(this);
    }

    onHandledCommand() {
      this._commandsToSend.shift();
      if (this._commandsToSend.length === 0) {
        messageBus.unsubscribe(
          "Gamble:DisclaimerVisible",
          this._disclaimerFunc
        );
        messageBus.unsubscribe("Gamble:IntroVisible", this._introVisibleFunc);
        messageBus.unsubscribe("Gamble:WaitForInput", this._waitForInputFunc);
        messageBus.unsubscribe("Gamble:HandledCommand", this._handledCommand);
        this._task.leave();
        this._task = undefined;
      }
    }

    onDisclaimerVisible() {
      messageBus.post("Gamble:OkDisclaimer");
    }

    onIntroVisible() {
      messageBus.post("Gamble:OfferGamble");
    }

    onWaitForInput() {
      let nextCommands = this._commandsToSend[0];
      if (nextCommands.indexOf("RISK") !== -1)
        messageBus.postImmediate("Gamble:Risk");
      else messageBus.postImmediate("Gamble:Collect");
    }

    setupRecoveryGame(task) {
      this._task = task;
      this._task.join();

      this._commandsToSend = JSON.parse(
        JSON.stringify(this._task.data.previousCommands.slice(1))
      ); // ignore Base command

      messageBus.subscribe("Gamble:DisclaimerVisible", this._disclaimerFunc);
      messageBus.subscribe("Gamble:IntroVisible", this._introVisibleFunc);
      messageBus.subscribe("Gamble:WaitForInput", this._waitForInputFunc);
      messageBus.subscribe("Gamble:HandledCommand", this._handledCommand);
    }

    onRecoverGameListener(task) {
      // are their commands here that took us to the gamble game?
      let commands = task.data.previousCommands;

      for (let i = 0; i < commands.length; ++i) {
        if (commands[i].indexOf("GAMBLE") !== -1) {
          this.setupRecoveryGame(task);
          break;
        }
      }
    }
  }

  resourceManager.registerController("RecoveryController", function () {
    return new RecoveryController();
  });
})();
